module.exports = __webpack_public_path__ + "img/Talent Recruitment@3x.2dca931b.png";